import React, { useState, useEffect } from "react";
import "./App.css";
import { Button, Container, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormItem from "./components/FormItem";
import ItemsSection from "./components/ItemsSection";
import AppFooter from "./components/AppFooter";
import "bootstrap/dist/css/bootstrap.min.css";
import _ from "lodash";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import OwedSection from "./components/OwedSection";
import OCRModal from "./components/OCRModal";
import { Item, Due, MAIN_BANNER_IMAGE } from "./common";

// Add the QR code icon to the library
library.add([faQrcode]);

/**
 * Main component.
 */
const App: React.FC<{}> = () => {
  const [items, setItems] = useState<Item[]>([]);
  const [dues, setDues] = useState<Due[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  // Update the dues
  useEffect(() => {
    const subtotalDues: Record<string, number> = {};

    items.forEach((item) => {
      item.people.forEach((person) => {
        if (!subtotalDues.hasOwnProperty(person)) {
          subtotalDues[person] = 0;
        }
        subtotalDues[person] += item.price / item.people.length;
      });
    });

    const subtotal = _.sumBy(items, (item) => item.price);

    const totalDues: Due[] = _.keys(subtotalDues).map((person) => ({
      name: person,
      cost: (subtotalDues[person] / subtotal) * total,
    }));

    setDues(totalDues);
  }, [total, items]);

  const addItem = (text: string, price: number, people: string[]): void =>
    setItems([...items, { text, price, people }]);

  const removeItem = (index: number): void => {
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);
  };

  const handleNewTotal = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const newTotal = e.target.value;
    if (!isNaN(parseFloat(newTotal))) {
      setTotal(parseFloat(newTotal));
    }
  };

  return (
    <div className="app">
      <div className="container">
        <h1 className="text-center mb-4 mt-4">Restaurant Bill Splitter</h1>
        <img
          className="main-image"
          alt={"SAO characters sitting at restaurant"}
          src={MAIN_BANNER_IMAGE}
        />
        <Container className="text-center mb-4 mt-4">
          <Button onClick={() => setModalOpen(true)} variant="warning">
            <FontAwesomeIcon icon="qrcode" /> Scan Receipt
          </Button>
        </Container>
        <FormItem addItem={addItem} initialName={""} initialCost={""} />
        <div className="total-input-div">
          <input
            className="total-input-box"
            onChange={handleNewTotal}
            type={"text"}
            placeholder="Total (Subtotal + Tax + Tip)"
          />
        </div>
        <ItemsSection dues={dues} items={items} removeItem={removeItem} />
        <OwedSection dues={dues} items={items} />
      </div>
      <Modal show={modalOpen} onHide={() => setModalOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Scan Receipt</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OCRModal addItem={addItem} />
        </Modal.Body>
      </Modal>
      <AppFooter />
    </div>
  );
};

export default App;
